import React, { useMemo } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAdditionalUserData from "../hooks/useAdditionalUserData";

export default function RequireAdminOrRedirect() {
  const location = useLocation();

  const headersSetCookie = localStorage.getItem("headersSetCookie");
  const persistedAccountUid = localStorage.getItem("accountUid");

  const additionalUserData = useAdditionalUserData();

  const roles = Array.isArray(additionalUserData?.roles) ? additionalUserData.roles : [];
  const isSuperUser = roles.includes("ROLE_SUPERUSER");
  const isOverviewMode = localStorage.getItem("isOverview") === "true";

  const redirectTo = useMemo(() => {
    if (!headersSetCookie) return "/login";

    if (!isSuperUser) {
      const currentPath = location.pathname;
      const pathAfterAdmin = currentPath.replace(/^\/dashboard\/admin/, "");

      if (isOverviewMode) {
        return `/dashboard/overview${pathAfterAdmin}`;
      }

      if (persistedAccountUid) {
        const reconstructed = `/dashboard/${persistedAccountUid}${pathAfterAdmin}`;
        if (!/^\/dashboard\/[a-f0-9-]{36}/i.test(reconstructed)) return "/dashboard/select";
        return reconstructed;
      }
      return "/dashboard/select";
    }

    return null;
  }, [headersSetCookie, isSuperUser, isOverviewMode, persistedAccountUid, location.pathname]);

  if (redirectTo) {
    const redirectState = !headersSetCookie ? { from: location } : null;
    return <Navigate to={redirectTo} state={redirectState} replace />;
  }
  return <Outlet />;
}
